// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "./Config.bs.js";
import * as Datadog from "./library/datadog/Datadog.bs.js";
import * as Js_dict from "../node_modules/rescript/lib/es6/js_dict.js";
import * as AppProvider from "./context/AppProvider.bs.js";
import * as Caml_option from "../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryConfig from "./country/CountryConfig.bs.js";
import * as RnrRouteManager from "./partner-web-apps/rnr/routing/RnrRouteManager.bs.js";
import * as N_RnRRouteManager from "./partner-web-apps/rnr-2w/routing/N_RnRRouteManager.bs.js";
import * as UrlUtils$Catalyst from "../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as Timestamp$Catalyst from "../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as RescriptReactRouter from "../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as SupportRouteManager from "./partner-web-apps/support/routing/SupportRouteManager.bs.js";
import * as TdsFormRouteManager from "./partner-web-apps/tds/routing/TdsFormRouteManager.bs.js";
import * as IncentiveRouteManager from "./partner-web-apps/incentive-dashboard/routing/IncentiveRouteManager.bs.js";
import * as InsuranceRouteManager from "./partner-web-apps/insurance-dashboard/routing/InsuranceRouteManager.bs.js";
import * as RouteComponentFactory from "./routing/RouteComponentFactory.bs.js";
import * as PartnerScoreRouteManager from "./partner-web-apps/partner-score/routing/PartnerScoreRouteManager.bs.js";
import * as TrackLiveTripRouteManager from "./partner-web-apps/track-live-trip/routing/TrackLiveTripRouteManager.bs.js";

function findSomeWithDefault(l, $$default) {
  var opt_r = List.fold_left((function (acc, func) {
          if (acc !== undefined) {
            return acc;
          } else {
            return Curry._1(func, undefined);
          }
        }), undefined, l);
  if (opt_r !== undefined) {
    return Caml_option.valFromOption(opt_r);
  } else {
    return $$default;
  }
}

var countryConfig = CountryConfig.getCountryConfig(Js_dict.get(UrlUtils$Catalyst.getURLParams(RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined).search), "country"));

function getInitialRoute(initialUrl) {
  return findSomeWithDefault({
              hd: (function (param) {
                  return N_RnRRouteManager.getRoute(initialUrl);
                }),
              tl: {
                hd: (function (param) {
                    return RnrRouteManager.RouteManager.getRnrDashboard(initialUrl);
                  }),
                tl: {
                  hd: (function (param) {
                      return TdsFormRouteManager.RouteManager.getTdsForm(initialUrl);
                    }),
                  tl: {
                    hd: (function (param) {
                        return InsuranceRouteManager.RouteManager.getRoute(initialUrl);
                      }),
                    tl: {
                      hd: (function (param) {
                          return IncentiveRouteManager.RouteManager.getRoute(initialUrl);
                        }),
                      tl: {
                        hd: (function (param) {
                            return PartnerScoreRouteManager.getRoute(initialUrl);
                          }),
                        tl: {
                          hd: (function (param) {
                              return SupportRouteManager.RouteManager.getRoute(initialUrl);
                            }),
                          tl: {
                            hd: (function (param) {
                                return TrackLiveTripRouteManager.RouteManager.getRoute(initialUrl);
                              }),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }, /* DefaultDashboard */0);
}

Timestamp$Catalyst.setTz(countryConfig._0.timeZone);

function App$App(Props) {
  var route = getInitialRoute(RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined));
  React.useEffect((function () {
          Datadog.initDatadogCfg(Config.Env.env, Config.Env.dd_app_id, Config.Env.dd_token, 0, 0);
          Datadog.startRecording(undefined);
          return (function (param) {
                    return Datadog.stopRecording(undefined);
                  });
        }), []);
  return React.createElement("div", {
              id: "map"
            }, React.createElement(AppProvider.make, AppProvider.makeProps({
                      countryConfig: countryConfig
                    }, RouteComponentFactory.getWebsiteComponentFromRoute(route), undefined)));
}

var App = {
  findSomeWithDefault: findSomeWithDefault,
  countryConfig: countryConfig,
  getInitialRoute: getInitialRoute,
  make: App$App
};

export {
  App ,
  
}
/* countryConfig Not a pure module */
